define('drops/progressBar/progressBar',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
	'use strict';

	var defaults = {
	    data: {
	        minValue: 0,
	        maxValue: 100
	    }
	};

    function ProgressBar(options) {
        Drop.call(this, $('<div/>'), defaults, options);
       
        this.$element.addClass('boxToBorderSize');

        this.$progress = $('<div />')
           .addClass('boxToBorderSize')
           .css({
               height: '100%'
           })
           .appendTo(this.$element);

        Style.renderStyles(this);
        Style.renderStyles(this, null, this.$progress, null, 'progress');

        this.$progress.css({ width: 0 + '%' });
    };
    
    Drop.extend(ProgressBar, Drop);

    ProgressBar.typeName = 'ProgressBar';

    ProgressBar.prototype.preRender = function () {
        this.piping.visibility.apply(this);
	    this.applyPosition();
    };

    ProgressBar.prototype.setValue = function (update) {
        this.setProgress(update.value);
    };

    ProgressBar.prototype.clearValue = function () {
        this.setProgress(0);
    };

    ProgressBar.prototype.setProgress = function (newValue) {
        var value = Math.max(this.data.minValue, Math.min(parseFloat(newValue), this.data.maxValue));
        var percentage = ((value - this.data.minValue) / (this.data.maxValue - this.data.minValue)) * 100;
        this.$progress.css({ width: percentage + '%' });
    };

    return ProgressBar;
});
